import { Box, ListItem, ListItemIcon, ListItemText, Skeleton } from '@mui/material';

function ListItemSkeleton(): React.JSX.Element {
  return (
    <ListItem
      secondaryAction={
        <Box display="flex" gap="4px">
          <Skeleton height={24} variant="circular" width={24} />
          <Skeleton height={24} variant="circular" width={24} />
        </Box>
      }
    >
      <ListItemIcon>
        <Skeleton height={20} variant="circular" width={20} />
      </ListItemIcon>
      <ListItemText
        primary={<Skeleton variant="text" width={200} />}
        secondary={<Skeleton variant="text" width={300} />}
      />
    </ListItem>
  );
}

export default ListItemSkeleton;
